import { createRootRoute } from "@tanstack/react-router";
import { RootLayout } from "./root";
import { NotFoundPage } from "./not-found";

// The router's root, in a file of its own so an area's route table can hang
// its routes from it without importing router.tsx (the platform console's
// table, areas/admin/console-routes.tsx, does).
//
// `notFoundComponent` is the DESIGNED 404 (routes/not-found.tsx). Without it
// TanStack renders a bare `<p>Not Found</p>` inside the full signed-in shell,
// with no way back — what `/terminology` (the real route is
// `/settings/terminology`) produced.
export const rootRoute = createRootRoute({
  component: RootLayout,
  notFoundComponent: NotFoundPage,
});
